import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import Footer from "./Components/footer";
import Navbar from "./Components/navbar";
import Blog from "./Pages/blog";
import Home from "./Pages/home";
import Instagram from "./Pages/instagram";
import TourDetails from "./Pages/tourdetails";
import Tours from "./Pages/tours";
import AboutUs from "./Pages/aboutUs";
import Contact from "./Pages/contact";
import Admin from "./Pages/admin";
import SwiperCarousel from "./Pages/carousel";
import Login from "./Components/Login";
import Unauthorized from "./Components/Unauthorized";
import ScrollToTop from "./utils/ScrollTo";
import { useEffect } from "react";
import RentACar from "./Pages/rentacar";
function App() {
  const location = useLocation();

  const navigate = useNavigate();

  useEffect(() => {
    if (window.location.pathname === "/") {
      navigate("/az/", { replace: true });
    }
  }, [navigate]);

  // Navbar və Footer-i yalnız admin paneldə gizlət
  const isAdminRoute = location.pathname.startsWith("/admin");
  const isLoginRoute = location.pathname.startsWith("/login");
  const isUnauthRoute = location.pathname.startsWith("/unauthorized");

  return (
    <>
      <ScrollToTop />
      {!isAdminRoute && !isLoginRoute && !isUnauthRoute && <Navbar />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />

        <Route path="/:lang/" element={<Home />} />
        <Route path="/:lang/aboutus" element={<AboutUs />} />
        <Route path="/:lang/contact" element={<Contact />} />
        <Route path="/:lang/blog/:id" element={<Blog />} />
        <Route path="/:lang/posts" element={<Instagram />} />
        <Route path="admin/*" element={<Admin />} />
        <Route path="/:lang/tour/:slug" element={<TourDetails />} />
        <Route path="/:lang/alltours" element={<Tours />} />
        <Route path="/:lang/rent" element={<RentACar />} />
      </Routes>
      {!isAdminRoute && !isLoginRoute && !isUnauthRoute && <Footer />}
    </>
  );
}

export default App;
